export interface IOpportunityAttachments {
  resource: string;
  address: string;
  path: string;
  caption: string | undefined;
}

export class OpportunityAttachments {
  public resource: string;
  public address: string;
  public path: string;
  public caption: string | undefined;

  constructor(data: IOpportunityAttachments) {
    this.resource = data.resource;
    this.address = data.address;
    this.path = data.path;
    this.caption = data.caption;
  }
}
